// extracted by mini-css-extract-plugin
export var box = "_98-1";
export var checked = "_98-2";
export var descriptionSpacer = "_98-9";
export var disabled = "_98-3";
export var icon = "_98-6";
export var input = "_98-0";
export var labelSpacer = "_98-8";
export var medium = "_98-5";
export var small = "_98-4";
export var text = "_98-7";